import Head from 'next/head';
import React from "react";

export default function MetaNoIndex() {
    return (
        <Head>
            <meta name="robots" content="noindex, nofollow"/>
        </Head>
    );
}